import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { CenteredState } from "./layouts";
import { Spinner } from "./ui";
import {
  authenticatedDestination,
  requiresStaffMfaSetup,
} from "../lib/authRouting";

export function AuthGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <CenteredState>
        <Spinner label="正在确认登录状态" />
      </CenteredState>
    );
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  const destination = authenticatedDestination(user, location.pathname);
  if (destination !== location.pathname)
    return <Navigate to={destination} replace />;
  if (
    location.pathname === "/mfa-setup" &&
    !requiresStaffMfaSetup(user)
  )
    return <Navigate to="/" replace />;
  return <Outlet />;
}

export function GuestGuard() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <CenteredState>
        <Spinner label="正在加载" />
      </CenteredState>
    );
  if (user)
    return (
      <Navigate
        to={authenticatedDestination(user)}
        replace
      />
    );
  return <Outlet />;
}

export function AdminGuard() {
  const { user } = useAuth();
  if (!user || !["OWNER", "ADMIN", "SUPPORT"].includes(user.role))
    return <Navigate to="/forbidden" replace />;
  return <Outlet />;
}

export function RoleGuard({
  allowed,
}: {
  allowed: Array<"OWNER" | "ADMIN" | "SUPPORT" | "LEARNER">;
}) {
  const { user } = useAuth();
  if (!user || !allowed.includes(user.role))
    return <Navigate to="/forbidden" replace />;
  return <Outlet />;
}
